import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  Avatar,
  Chip
} from '@mui/material';
import {
  Send,
  CallReceived,
  SwapHoriz,
  LinkOff
} from '@mui/icons-material';

const VdexDetails = ({ 
  wallet, 
  onClose, 
  onSend, 
  onReceive, 
  onSwap, 
  onDisconnect,
  testnetWallets
}) => {
  const [walletData, setWalletData] = useState(wallet);

  // Find the wallet in testnetWallets to get the updated balance
  useEffect(() => {
    if (wallet && testnetWallets && Array.isArray(testnetWallets)) {
      const foundWallet = testnetWallets.find(w => w.address === wallet.address);
      if (foundWallet) {
        setWalletData(foundWallet);
      }
    }
  }, [wallet, testnetWallets]);

  if (!walletData) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography>No wallet data available</Typography>
        <Button onClick={onClose} sx={{ mt: 2 }}>Close</Button>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Avatar sx={{ bgcolor: 'primary.dark', width: 50, height: 50 }}>
            {walletData.icon || '💼'}
          </Avatar>
          <Box>
            <Typography variant="h6">Vdex Details</Typography>
            <Typography variant="body2" color="text.secondary">
              {walletData.network || 'Ethereum Network'}
            </Typography>
          </Box>
        </Box>
        <Chip label="Connected" color="success" />
      </Box>

      <Box sx={{ mb: 3 }}>
        <Typography variant="subtitle2" color="text.secondary">Address</Typography>
        <Typography variant="body1" sx={{ wordBreak: 'break-all', fontFamily: 'monospace' }}>
          {walletData.address}
        </Typography>
      </Box>

      <Box sx={{ mb: 3 }}>
        <Typography variant="subtitle2" color="text.secondary">Network</Typography>
        <Typography variant="body1">
          {walletData.network || 'Ethereum Testnet (Sepolia)'}
        </Typography>
      </Box>

      <Box sx={{ mb: 3 }}>
        <Typography variant="subtitle2" color="text.secondary">Balance</Typography>
        <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
          {walletData.balance || '0 ETH'}
        </Typography>
      </Box>

      <Box sx={{ mb: 3 }}>
        <Typography variant="subtitle2" color="text.secondary">Wallet Type</Typography>
        <Typography variant="body1">
          {walletData.type === 'hardware' ? 'Hardware Wallet' : 'Hot Wallet'}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mt: 4 }}>
        <Button
          variant="outlined"
          startIcon={<Send />}
          onClick={() => onSend && onSend(walletData)}
        >
          SEND
        </Button>
        <Button
          variant="outlined"
          startIcon={<CallReceived />}
          onClick={() => onReceive && onReceive(walletData)}
        >
          RECEIVE
        </Button>
        <Button
          variant="outlined"
          startIcon={<SwapHoriz />}
          onClick={() => onSwap && onSwap(walletData)}
        >
          SWAP
        </Button>
        <Button
          variant="outlined"
          color="error"
          startIcon={<LinkOff />}
          onClick={() => onDisconnect && onDisconnect(walletData)}
        >
          DISCONNECT
        </Button>
      </Box>

      <Box sx={{ mt: 3, textAlign: 'center' }}>
        <Button onClick={onClose} variant="contained" color="primary">
          CLOSE
        </Button>
      </Box>
    </Box>
  );
};

export default VdexDetails;
